import axios from 'axios';
import moment from 'moment';

const downloadChargingPilePriceSetting = async () => {
  const priceUrl = `${location.origin}/ezcon/api/chargingPileElectricityRatePDF`;
  const { data } = await axios.get(priceUrl, {
    headers: {
      authorization: localStorage.getItem('feathers-jwt'),
    },
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${moment().format('YYYYMMDD')}充電樁費率.pdf`;
  link.click();
};

export default downloadChargingPilePriceSetting;
